import './App.css';
import { HashRouter, Routes, Route } from 'react-router-dom'; 
import axios from 'axios'; 
import {api_base_url} from './common/Constants';

import Home from './pages/Home';
import About from './pages/About';
import Quality from './pages/Quality';
import Certificates from './pages/Certificates';
import Products from './pages/Products'; 
import ProjectList from './pages/ProjectList';
import Projects from './pages/Projects';
import ProjectInfo from './pages/ProjectInfo';
import Clients from './pages/Clients';
import Contact from './pages/Contact';
import Services from './pages/Services';
import ApplyNow from './pages/ApplyNow';
import Blog from './pages/Blog';
import BlogInfo from './pages/BlogInfo';
import DivisionInfo from './pages/DivisionInfo';
import CMMessage from './pages/CMMessage';
import Cms from './pages/Cms';
import Vision from './pages/Vision';
import Maintenance from './pages/Maintenance';
import Careers from './pages/Careers'; 
import React, { useEffect, useState } from 'react';


function App() {

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const res = await fetch(api_base_url+"get-all-data");
        const data = await res.json();
        
        localStorage.setItem("content", JSON.stringify(data.content));
        localStorage.setItem("settings", JSON.stringify(data.settings));
        localStorage.setItem("banners", JSON.stringify(data.banners)); 
        localStorage.setItem("careers", JSON.stringify(data.careers)); 
        localStorage.setItem("home_banners", JSON.stringify(data.home_banners)); 
        localStorage.setItem("page_banners", JSON.stringify(data.page_banners)); 
        localStorage.setItem("maintenances", JSON.stringify(data.maintenances)); 
        localStorage.setItem("projects", JSON.stringify(data.projects));
        localStorage.setItem("certificates", JSON.stringify(data.certificates));
        localStorage.setItem("services", JSON.stringify(data.services));
        localStorage.setItem("project_list", JSON.stringify(data.projectlists)); 
        localStorage.setItem("clients", JSON.stringify(data.clients)); 
        localStorage.setItem("project_types", JSON.stringify(data.projecttypes));  
        localStorage.setItem("divisions", JSON.stringify(data.divisions)); 
        localStorage.setItem("services_types", JSON.stringify(data.services_types)); 
        localStorage.setItem("divisions_slug", JSON.stringify(data.divisions_slug)); 
        localStorage.setItem("metas", JSON.stringify(data.metas)); 
        setLoading(false);
      } catch (err) {
        console.error(err);
      }
    };
  
    fetchSettings();
  }, []);
  
   
  if (loading) return <div class="loader">Loading...</div>;
 
  return (
    <div>  
      <HashRouter>
      <Routes>
      <Route  path="/" element={<Home />} > </Route>
      <Route  path="/about-us" element={<About />} > </Route> 
      <Route  path="/vision-mission" element={<Vision />} > </Route> 
      <Route  path="/certificates" element={<Certificates />} > </Route> 
      <Route  path="/maintenance-services" element={<Maintenance />} > </Route> 
      <Route  path="/services" element={<Services />} > </Route> 
      <Route  path="/projects" element={<Projects />} > </Route>
      <Route  path="/clients" element={<Clients />} > </Route>
      <Route  path="/contact-us" element={<Contact />} > </Route>
      <Route  path="/ongoing-projects" element={<ProjectList />} > </Route> 
      <Route  path="/project-info/:id" element={<ProjectInfo />} > </Route>  
      <Route  path="/blog" element={<Blog />} > </Route> 
      <Route  path="/blog-info/:id" element={<BlogInfo />} > </Route> 
      <Route  path="/apply-now/:id" element={<ApplyNow />} > </Route> 
      <Route  path="/divisions/:id" element={<DivisionInfo />} > </Route> 
      <Route  path="/careers" element={<Careers />} > </Route> 
      <Route  path="/apply-now/:id" element={<ApplyNow />} > </Route> 
      <Route  path="/:slug" element={<Cms />} > </Route> 
      
      </Routes>
    </HashRouter> 
  </div>
     
  );
}

export default App;